import { render, staticRenderFns } from "./ClaimsPreview.vue?vue&type=template&id=6815752b&scoped=true&"
import script from "./ClaimsPreview.vue?vue&type=script&lang=js&"
export * from "./ClaimsPreview.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsPreview.vue?vue&type=style&index=0&id=6815752b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6815752b",
  null
  
)

export default component.exports